// removed by extract-text-webpack-plugin
module.exports = {"root":"menu__root--e_nDw","bgPanBottomTop":"menu__bgPanBottomTop--35UQL","closing":"menu__closing--1yFtO","navigation":"menu__navigation--2R0os","mainLinks":"menu__mainLinks--31Z8d","mainListItem":"menu__mainListItem--q1AGt","secondaryListItem":"menu__secondaryListItem--1DgEj","secondaryLinks":"menu__secondaryLinks--ywyPk","mainLink":"menu__mainLink--h87cM","linksPop":"menu__linksPop--waFga","secondaryLink":"menu__secondaryLink--16dSE menu__mainLink--h87cM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Menu/menu.css
// module id = vPAK
// module chunks = 0